import { useRouter } from 'next/router'
import SearchFlightForm from '~/components/search-and-results/SearchFlightForm'
import { useAccount } from '~/context/account'
import { useUser } from '~/context/user'
import { useNavigationAnalytics } from '~/hooks/useNavigationAnalytics'
import { flightPageDetails } from '~/utils/googleTagManager/googleTagManagerHelperFunctions'

export function SearchFlightFormWrapper() {
  const { onNavigate } = useNavigationAnalytics()
  const router = useRouter()
  const userContext = useUser()
  const { aviosBalance } = useAccount()

  const handleOnSearchAnalytics = () =>
    onNavigate({
      navType: 'cta',
      navAction: 'search flights',
      extra: { event: 'navigation', ...flightPageDetails(router, userContext, aviosBalance) },
    })

  return <SearchFlightForm onValidSubmit={handleOnSearchAnalytics} />
}
